import angular from "angular";
import ngAnimate from "angular-animate";
import ngSanitize from "angular-sanitize";
import ngTouch from "angular-touch";
import uiDatepicker from "angular-ui-bootstrap/src/datepickerPopup";
import uiSelect from "ui-select";

export default angular
  .module("controllers.agendaSearch", [
    ngAnimate,
    ngSanitize,
    ngTouch,
    uiSelect,
    uiDatepicker,
  ])
  .controller("AgendaSearchController", [
    function() {
      this.eventType = "all";
      this.eventTypes = [
        {
          value: "all",
          label: "Todos",
        },
        {
          value: "release",
          label: "Lançamentos",
        },
        {
          value: "saleLimit",
          label: "Limites de vendas",
        },
      ];
      this.datepickerFormat = "dd/MM/yyyy";
      this.datepickerOptions = { showWeeks: false };
      this.datepickers = {
        from: { opened: false },
        to: { opened: false },
      }

      this.openDatepicker = datepicker => {
        datepicker.opened = true;
      }
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/agenda-search-controller.js